import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { createPath } from 'history';
import { useInvariableMemo } from '../invariable-hooks';
const parseParams = (search) => {
    const params = new URLSearchParams(search);
    const out = {};
    params.forEach((value, key) => (out[key] = value));
    return out;
};
const stringifyParams = (params) => new URLSearchParams(params).toString();
function useQueryParams(handler) {
    const history = useHistory();
    const search = history.location.search || '';
    const memoHandler = useInvariableMemo(() => handler);
    return useMemo(() => {
        const currentValues = memoHandler ? memoHandler.parse(search) : parseParams(search);
        const stringify = (params) => memoHandler ? memoHandler.toString(params) : stringifyParams(params);
        const createPathWithParams = (pathName, params) => createPath({ pathname: pathName, search: stringify(params) });
        const update = (params) => {
            history.replace(createPathWithParams(history.location.pathname, params));
        };
        return {
            values: currentValues,
            update,
            updatePartial: (params) => update(Object.assign(Object.assign({}, currentValues), params)),
            push: (pathName, params) => {
                history.push(createPathWithParams(pathName, params));
            },
            replace: (pathName, params) => {
                history.replace(createPathWithParams(pathName, params));
            },
            path: createPathWithParams,
            href: (pathName, params) => history.createHref({
                pathname: createPath({ pathname: pathName, search: stringify(params) }),
            }),
        };
    }, [search, memoHandler, history]);
}
export { useQueryParams };
//# sourceMappingURL=use-query-params.js.map